import { render, staticRenderFns } from "./CustomerHealthReports.vue?vue&type=template&id=be043198&scoped=true&"
import script from "./CustomerHealthReports.vue?vue&type=script&lang=ts&"
export * from "./CustomerHealthReports.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerHealthReports.vue?vue&type=style&index=0&id=be043198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be043198",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VCard,VContainer,VIcon,VStepper,VStepperContent})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be043198')) {
      api.createRecord('be043198', component.options)
    } else {
      api.reload('be043198', component.options)
    }
    module.hot.accept("./CustomerHealthReports.vue?vue&type=template&id=be043198&scoped=true&", function () {
      api.rerender('be043198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/health-reports/views/CustomerHealthReports.vue"
export default component.exports